import { render } from "./FaceGrid.vue?vue&type=template&id=1bc84734&scoped=true"
import script from "./FaceGrid.vue?vue&type=script&lang=js"
export * from "./FaceGrid.vue?vue&type=script&lang=js"

import "./FaceGrid.vue?vue&type=style&index=0&id=1bc84734&scoped=true&lang=css"

import exportComponent from "/Users/daiabromberg/Downloads/Parsons_Spring/MS2/msdv-thesis/Project/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc84734"]])

export default __exports__